// extracted by mini-css-extract-plugin
module.exports = {"comp":"Dialog3_comp__nhAiF"};